<template>
  <div>
    <div class="login" v-if="!isRegisterFlag && !isResetFlag">
      <div class="login-tabs">
        <div class="login-tabs-left">
          <div class="list line">
            <span @click="toggleTabs(0)" :class="activeTabs == 0 ? 'tabsLoginActive' : ''">密码登录</span>
          </div>
          <div class="list" style="margin-left: 42px">
            <span @click="toggleTabs(1)" :class="activeTabs == 1 ? 'tabsLoginActive' : ''">验证码登录</span>
          </div>
        </div>
        <div class="login-tabs-right" v-if="currentRole == '学生'">
          <span @click="goRegister">注册</span>
        </div>
      </div>

      <div class="content-list">
        <!-- 密码登录 -->
        <template v-if="activeTabs == 0">
          <div class="list">
            <div class="list-top"><span>账号</span></div>
            <div class="list-bottom">
              <el-input v-model="userNamePwd" placeholder="用户名/手机号/邮箱" @blur="rememberPwd(false)"></el-input>
            </div>
          </div>
          <div class="list">
            <div class="list-top"><span>密码</span></div>
            <div class="list-bottom">
              <el-input v-model="pwd" :type="!isOpenEye ? 'password' : 'text'" autocomplete="new-password"
                placeholder="请输入密码"></el-input>
              <img v-if="isOpenEye" @click="openEye" src="@/assets/images/login/close-eye.png" alt="" />
              <img v-if="!isOpenEye" @click="openEye" src="@/assets/images/login/open-eye.png" alt="" />
            </div>
          </div>
        </template>
        <!-- 验证码登录 -->
        <template v-if="activeTabs == 1">
          <div class="list">
            <div class="list-top"><span>账号</span></div>
            <div class="list-bottom">
              <el-input v-model="userNameCode" autocomplete="off" placeholder="手机号/邮箱"></el-input>
            </div>
          </div>
          <div class="list">
            <div class="list-top"><span>验证码</span></div>
            <div class="list-bottom">
              <el-input v-model="code" placeholder="请输入验证码" autocomplete="new-password" style="width: 228px"></el-input>
              <!-- <el-button type="primary" plain>获取验证码</el-button> -->
              <code-msg-new application="service-user" :account="userNameCode" :type="loginType"
                :validator="verification" @on-success="sessionId = $event" @formPass="formPass"
                ref="codeMsgNew"></code-msg-new>
            </div>
          </div>
        </template>
        <div class="password" v-if="activeTabs == 0">
          <el-checkbox v-model="isRemember" @change="rememberPwd">记住密码</el-checkbox>
          <span @click="goReset">忘记密码？</span>
        </div>
        <div class="btn" @click="Login">登录</div>
        <div class="roleChange">
          <span class="rules" :class="currentRole == '教师' ? 'rulesActive' : ''" @click="toggleRoles('教师')">我是教师</span>
          <span class="rules" :class="currentRole == '学生' ? 'rulesActive' : ''" @click="toggleRoles('学生')">我是学生</span>
        </div>
      </div>
    </div>
    <Verify ref="verify" :captcha-type="captchaType" :img-size="{ width: '400px', height: '200px' }"
      @success="verifySuccess" @closeBox="closeBox" />
    <register v-if="isRegisterFlag && !isResetFlag" @goLogin="goLogin"></register>
    <resetpwd v-if="isResetFlag && !isRegisterFlag" @goLogin="goLogin"></resetpwd>
  </div>
</template>

<script>
import register from "./register.vue";
import resetpwd from "./resetpwd.vue";
import login from "@/assets/mix/login.js";
import codeMsgNew from "@/components/startPage/code-msg-new.vue";
import Verify from '@/components/common/verify/Verify.vue'
import { Base64 } from "js-base64";
export default {
  name: "VirtualimitationLogin",
  components: {
    register,
    resetpwd,
    codeMsgNew,
    Verify
  },
  mixins: [login],
  data () {
    return {
      activeTabs: 0,
      isOpenEye: false, //是否显示密码
      isRemember: false, //是否记住密码
      currentRole: "学生", //当前角色
      userNamePwd: "", //用户名/手机号/邮箱  //密码登录
      userNameCode: "", //手机号/邮箱 验证码登录
      pwd: "", //密码
      code: "", //验证码
      isRegisterFlag: false, //是否注册
      isResetFlag: false, //是否忘记密码
      loginType: "password", //登录方式  默认为password
      isHasTruePhone: true, //判断是否存在该手机号
      sessionId: "",
      rememberRole: "",
      captchaType: 'clickWord'
    };
  },

  mounted () {
    this.get_Cookie();
  },

  methods: {
    // 表单通过验证之后，获取图形验证码
    formPass () {
      let randomNum = Math.floor(Math.random() * 2) + 1
      this.captchaType = randomNum == 1 ? 'clickWord' : 'blockPuzzle'
      this.$refs.verify.show()
    },
    // 图形验证码成功的回调
    verifySuccess (captchaVerification) {
      this.$refs.codeMsgNew.sendCodeNew(captchaVerification)
    },
    // 关闭图像验证码窗口的回调
    closeBox () {
      this.$refs.codeMsgNew.loading = false
      this.$refs.codeMsgNew.btnText = '发送验证码'
    },
    //记住密码
    rememberPwd (val) {
      this.isRemember = val;
      if (val) {
        //设置cookie
        this.set_Cookie(this.userNamePwd, this.pwd, this.currentRole, 7); //存储七天
      } else {
        //清除cookie
        this.set_Cookie("", "", "", -10000); //清除cookie
      }
    },
    //设置cookie
    set_Cookie (c_name, c_pwd, c_role, c_expires) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * (c_expires + 8)); //保存的天数  由于获取到的时间是格林尼治时间，所以获取本地时间需要加8小时
      //字符串拼接cookie  加密
      window.document.cookie =
        "vspUName" +
        "=" +
        Base64.encode(c_name) +
        ";path=/;expires=" +
        exdate.toGMTString();
      window.document.cookie =
        "vspUPwd" +
        "=" +
        Base64.encode(c_pwd) +
        ";path=/;expires=" +
        exdate.toGMTString();
      window.document.cookie =
        "currentRole" +
        "=" +
        Base64.encode(c_role) +
        ";path=/;expires=" +
        exdate.toGMTString();
    },
    //获取cookie
    get_Cookie () {
      if (document.cookie.length > 0) {
        let arr = document.cookie.split(";");
        for (let i = 0; i < arr.length; i++) {
          let arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0].trim() == "vspUName") {
            this.userNamePwd = Base64.decode(arr2[1].trim()); //保存到保存数据的地方 Base64.decode()  解密
            if (arr2[1] != "") {
              this.isRemember = true;
            }
          } else if (arr2[0].trim() == "vspUPwd") {
            this.pwd = Base64.decode(arr2[1].trim());
          } else if (arr2[0].trim() == "currentRole") {
            this.currentRole = Base64.decode(arr2[1].trim());
            this.rememberRole = this.currentRole;
          }
        }
      }
    },
    //验证码 验证
    async verification (callback) {
      if (this.userNameCode == "") {
        this.getTips("账号不能为空", "warning");
        return;
      }
      const isMobile = this.$util.tools.verifyMobile(this.userNameCode); //检测是否是手机号
      const isEmail = this.$util.tools.verifyEmail(this.userNameCode); //检测是否是邮箱
      if (isMobile) {
        this.loginType = "phoneNumber";
        await this.CheckPhoneUserExist(this.userNameCode);
        if (!this.isHasTruePhone) return;
      } else if (isEmail) {
        this.loginType = "email";
      } else {
        this.getTips("账号格式不正确，请重新输入", "warning");
        return;
      }
      callback();
    },
    //登录
    async Login () {
      //验证码登录
      this.userNameCode = this.userNameCode.trim();
      this.userNamePwd = this.userNamePwd.trim();
      this.pwd = this.pwd.trim();
      if (this.activeTabs == 1) {
        if (this.userNameCode == "") {
          this.getTips("账号不能为空", "warning");
          return;
        }
        this.code = this.code.trim();
        if (this.code == "") {
          this.getTips("验证码不能为空", "warning");
          return;
        }
        const isMobile = this.$util.tools.verifyMobile(this.userNameCode); //检测是否是手机号
        const isEmail = this.$util.tools.verifyEmail(this.userNameCode); //检测是否是邮箱
        if (isMobile) {
          this.loginType = "phoneNumber";
          await this.CheckPhoneUserExist(this.userNameCode);
          if (!this.isHasTruePhone) return;
        } else if (isEmail) {
          this.loginType = "email";
        } else {
          this.getTips("账号格式不正确，请重新输入", "warning");
          return;
        }
      }
      //密码登录
      if (this.activeTabs == 0) {
        this.loginType = "password";
        if (this.userNamePwd == "") {
          this.getTips("账号不能为空", "warning");
          return;
        }
        if (this.pwd == 0) {
          this.getTips("密码不能为空", "warning");
          return;
        }
      }
      if (this.isRemember == true) {
        //是否记住密码  true 则将账号和密码存储到本地
      }
      if (this.currentRole == "学生") {
        localStorage.setItem("type", 2);
      } else if (this.currentRole == "教师") {
        localStorage.setItem("type", 1);
      }
      if (this.loginType == "password") {
        this.login(this.loginType, this.userNamePwd, this.pwd);
      } else {
        this.login(this.loginType, this.userNameCode, this.code);
      }
    },
    openEye () {
      this.isOpenEye = !this.isOpenEye;
    },
    //验证手机号是否存在
    async CheckPhoneUserExist (value) {
      let res = await this.$api.user.CheckPhoneUserExist(value);
      if (res.errCode !== 0) {
        this.getTips("该手机号不存在", "warning");
        this.isHasTruePhone = false;
      }
    },
    toggleTabs (index) {
      this.activeTabs = index;
      this.clear();

      if (index == 0) {
        this.$nextTick(() => {
          this.get_Cookie();
        });
      }
    },
    //注册  只有学生才有注册
    goRegister () {
      this.isRegisterFlag = true;
      this.isResetFlag = false;
    },
    goLogin () {
      this.isRegisterFlag = false;
      this.isResetFlag = false;
    },
    //忘记密码
    goReset () {
      this.isResetFlag = true;
      this.isRegisterFlag = false;
    },
    //切换角色
    toggleRoles (role) {
      console.log(role);
      this.currentRole = role;
      this.clear();
      this.isRemember = false;
      if (this.rememberRole == role) {
        this.isRemember = true;
        this.get_Cookie();
      }
      //
    },
    //清空
    clear () {
      this.userNamePwd = "";
      this.userNameCode = "";
      this.pwd = "";
      this.code = "";
    },
    //获取提示
    getTips (msg, type) {
      this.$message({
        showClose: true,
        message: msg,
        type: type,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.roleChange {
  display: flex;
  justify-content: space-around;
}

.login {
  width: 423px;
  //   height: 450px;
  background: #ffffff;
  box-shadow: 0px 3px 14px rgba(122, 135, 155, 0.16);
  opacity: 1;
  border-radius: 4px;
  padding: 40px 30px 32px;
  box-sizing: border-box;

  .login-tabs {
    display: flex;
    justify-content: space-between;

    .login-tabs-left {
      display: flex;
      justify-content: start;

      .list {
        position: relative;

        span {
          padding-bottom: 8px;
          font-size: 16px;
          font-family: PingFang-SC;
          font-weight: 500;
          line-height: 22px;
          color: #747f8f;
          opacity: 1;
          cursor: pointer;
        }
      }
    }

    .login-tabs-right {
      span {
        padding-bottom: 8px;
        font-size: 16px;
        font-family: PingFang-SC;
        font-weight: 500;
        line-height: 22px;
        color: #747f8f;
        opacity: 1;
        cursor: pointer;
      }
    }
  }

  .content-list {
    margin-top: 34px;

    .list {
      margin-bottom: 20px;

      .list-top {
        margin-bottom: 8px;

        span {
          font-size: 14px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 20px;
          color: #424346;
          opacity: 1;
        }
      }

      .list-bottom {
        position: relative;
        display: flex;
        justify-content: space-between;

        .el-input {
          width: 363px;
          height: 42px;
        }

        img {
          width: 17.8px;
          height: 11.5px;
          position: absolute;
          bottom: 15px;
          right: 12px;
          cursor: pointer;
        }
      }
    }
  }

  .password {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-family: PingFang-SC;
    font-weight: 400;
    line-height: 17px;
    color: #1880fa;
    opacity: 1;

    span {
      cursor: pointer;
    }
  }

  .btn {
    width: 363px;
    height: 42px;
    background: #1880fa;
    opacity: 1;
    border-radius: 4px;
    margin: 41px auto 22px;
    line-height: 42px;
    text-align: center;
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 500;
    color: #ffffff;
    opacity: 1;
    cursor: pointer;
  }

  .rules {
    display: block;
    margin: 0 auto;
    width: 56px;
    height: 20px;
    font-size: 14px;
    font-family: PingFang-SC;
    font-weight: 400;
    line-height: 20px;
    opacity: 1;
    cursor: pointer;
  }
}

.rulesActive {
  color: #1880fa;
  text-decoration: underline;
}

.line {
  &::before {
    content: "";
    display: block;
    width: 0px;
    height: 19px;
    border: 1px solid #dfe3eb;
    opacity: 1;
    position: absolute;
    top: 3px;
    right: -22px;
  }
}

.tabsLoginActive {
  border-bottom: 2px solid #1880fa;
}
</style>